import React from 'react';

const Footer = () => {
  return <div className='absolute-center' style={{color: "gray",backgroundColor: "#f8f8f8"}}>
      Created by<a href="https://github.com/Vishmay919" style={{margin:"16px", color:"black",textDecoration:"none"}}> Vishmay Chauhan</a>
  </div>;
};

export default Footer;
